import Header from './components/Header';
import Hero from './components/Hero';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import FAQSection from './components/FAQSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CardsSection />
        <CarouselSection />
        <CommentsSection />
        <AppSection />
        <AboutSection />
        <ContactSection />
        <RankingSection />
        <UpdatesSection />
        <FAQSection />
        <FeaturesSection />
        <IndexSection />
        <TopicsSection />
        <MediaSection />
      </main>
      <Footer />
    </>
  );
}